<template>
	<div id="app">
		<transition :name="transitionName">
			<keep-alive include="placeOrder">
				<router-view   />
			</keep-alive>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				transitionName: 'transitionLeft',
				dataPath: [{
					path: 'enterprise',
					int: 0,
					name: '公司介绍'
				}, {
					path: 'service',
					int: 1,
					name: '服务内容'
				}, {
					path: 'cases',
					int: 2,
					name: '服务案例'
				}, {
					path: 'servingCustomers',
					int: 3,
					name: '服务客户'
				}, {
					path: 'honor',
					int: 4,
					name: '企业荣誉'
				}, {
					path: 'recruit',
					int: 5,
					name: '企业招聘'
				}, {
					path: 'culture',
					int: 6,
					name: '企业文化'
				},{
          path: 'administration',
          int: 7,
          name: '公司管理层'
        }, {
          path: 'course',
          int: 8,
          name: '企业历程'
        }, {
          path: 'contactus',
          int: 9,
          name: '联系我们'
        }]
			}
		},
		watch: { //使用watch 监听$router的变化
			$route(to, from) {
				console.log(to);
				console.log(from);
				if (from.fullPath == "/") {
					this.transitionName = null;
					return false
				}
				//如果to索引大于from索引,判断为前进状态,反之则为后退状态
				const arr = ['/enterprise', '/service', '/cases', '/servingCustomers', '/honor', '/recruit', '/culture','/administration','/course','/contactus'];
				this.transitionName = arr.indexOf(to.path) > arr.indexOf(from.path) ? 'transitionLeft' : 'transitionRight'


			},
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	* {
		-webkit-transition: all .5s ease-in-out;
		transition: all .5s ease-in-out;
		margin: 0px auto;
	}

	html,
	body {
		-webkit-touch-callout: none;
		width: 100%;
		font-family: arial;
		position: relative;
		font-family: arial;
		min-height: 100%;
	}

	body {
		line-height: 1.5;
		font-size: 16px;
		color: #000;
		outline: 0;
	}

	a {}

	html,
	body,
	header,
	section,
	footer,
	div,
	ul,
	ol,
	li,
	img,
	a,
	span,
	em,
	del,
	legend,
	center,
	strong,
	var,
	fieldset,
	form,
	label,
	dl,
	dt,
	dd,
	cite,
	input,
	hr,
	time,
	mark,
	code,
	figcaption,
	figure,
	textarea,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p {
		margin: 0;
		border: 0;
		padding: 0;
		font-style: normal;
	}

	ul,
	li {
		list-style: none;
	}

	b,
	strong {
		font-weight: 700;
	}

	pre {
		overflow: auto;
	}

	img {
		border: none;
		vertical-align: middle;
		max-width: 100%;
	}

	p {
		margin-top: 0;
		margin-bottom: 0;
	}

	a {
		text-decoration: none;
		color: #333;
	}

	a:hover {
		outline: 0;
	}

	textarea {
		overflow: hidden;
		resize: none;
	}

	button {
		overflow: visible;
	}

	button,
	select {
		text-transform: none;
	}

	button,
	input,
	optgroup,
	select,
	textarea {
		margin: 0;
		font: inherit;
		color: inherit;
	}

	hr {
		height: 0;
		-webkit-box-sizing: content-box;
		-moz-box-sizing: content-box;
		box-sizing: content-box;
	}

	pre {
		overflow: auto;
	}

	.cle:after {
		visibility: hidden;
		display: block;
		font-size: 0;
		content: " ";
		clear: both;
		height: 0
	}

	.cle {
		zoom: 1
	}

	.fl,
	.fr {
		display: inline
	}

	.fl {
		float: left
	}

	.fr {
		float: right
	}

	.txtov {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}

	input,
	textarea,
	select,
	button {
		outline: none;
		vertical-align: middle;
		font-size: inherit;
		font-family: inherit;
	}

	textarea {
		resize: none;
		overflow-y: auto;
	}

	input[type="submit"],
	input[type="reset"],
	input[type="button"],
	button {
		cursor: pointer;
		-webkit-appearance: none;
	}

	hr {
		height: 0;
		border-width: 1px 0 0 0;
		border-style: solid;
		margin: 0;
		color: #ddd;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-weight: normal;
		margin: 0;
	}

	ul,
	ol,
	li {
		list-style: none;
		-webkit-padding-start: 0
	}

	dt,
	dd {
		padding: 0;
		margin: 0;
		list-style: none;
	}

	html {
		width: 100%;
		margin: 0px auto;
	}

	body {
		margin: 0px auto;
	}

	.el-message {
		text-align: center;

		i {
			margin: 0px;
			margin-right: 10px;
			display: inline-block;
		}
	}

	.el-message__icon {
		display: contents;
	}

	.el-message__content {
		padding-left: 10px;
	}


	.transitionBody {
		transition: all 0.2s ease-out;
	}

	.transitionLeft-enter,
	.transitionRight-leave-active {
		-webkit-transform: translate(100%, 0);
		transform: translate(100%, 0);
	}

	.transitionLeft-leave-active,
	.transitionRight-enter {
		-webkit-transform: translate(-100%, 0);
		transform: translate(-100%, 0);
	}

	.transitionLeft-enter-active,
	.transitionRight-enter-active {

		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
	}


	/*
  .fold-left-enter-active {
    animation-name: fold-left-in;
    animation-duration: .6s;
  }

  .fold-left-leave-active {
    animation-name: fold-left-out;
    animation-duration: .6s;
  } */
	/*
  @keyframes fold-left-in {
    0% {
      opacity: 0;
    }


    100% {
      opacity: 1;
    }
  }

  @keyframes fold-left-out {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  .fold-right-enter-active {
    animation-name: fold-right-in;
    animation-duration: .3s;
  }

  .fold-right-leave-active {
    animation-name: fold-right-out;
    animation-duration: .3s;
  }

  @keyframes fold-right-in {
    0% {
      opacity: 0;
    }


    100% {
      opacity: 1;
    }
  }

  @keyframes fold-right-out {
    0% {
     opacity: 1;
    }


    100% {
      opacity: 0;
    }
  } */


	/* .img_box img {
  	width: 100%;
  	-webkit-transition: all .3s ease-in-out;
  	transition: all .3s ease-in-out;
  }

  .img_box:hover img {
  	-webkit-transform: scale(1.1, 1.1);
  	-ms-transform: scale(1.1, 1.1);
  	transform: scale(1.1, 1.1);
  } */
</style>



// WEBPACK FOOTER //
// src/App.vue